import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Milestone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  markMilestoneAsCompleted(
    request: Boundaries["markMilestoneAsCompleted"]["request"],
  ): void;
}

function useMarkMilestoneAsCompleted(
  milestone: Identifiable<Milestone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isMarkMilestoneAsCompletedRequestPending(milestone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isMarkMilestoneAsCompletedRequestSuccess(milestone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isMarkMilestoneAsCompletedRequestFailure(milestone),
    ),
    markMilestoneAsCompleted: core.markMilestoneAsCompleted,
  };
}

export { useMarkMilestoneAsCompleted };
